import PieChartElement from '@/views/elements/chart/PieChartElement';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import classNames from 'classnames/bind';
import styles from './InvestmentZoningChart.module.scss';
import './InvestmentZoningChart.scss';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

type Props = {
    dataSeries: any
    fullWidth?: boolean
    // accountId: string
    // masterAccount?: string
    // cosrole: string
}

export default function InvestmentZoningChart({ dataSeries, fullWidth }: Props) {
    const { t } = useTranslation()

    return (
        <Stack spacing={"20px"} p={"20px"} direction="column" className={fullWidth ? cx("pie-chart", "full-width") : cx("pie-chart")}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <TypographyElement FontWeightElement={700} FontSizeElement='16px' lineHeight='24px'>
                    {t('copytrade.chart.investZoning')}
                </TypographyElement>
            </Stack>
            <div className={cx("img-pie-chart")}>
                <PieChartElement
                    dataSeries={dataSeries}
                    isLongLabel={true}
                />
            </div>
        </Stack>
    )
}